import React from "react";
import { useI18n } from "@/i18n/I18nProvider";

export const LegalPage = ({ i18nKey }) => {
  const { dict } = useI18n();
  const data = dict[i18nKey];
  return (
    <div data-testid={`legal-${i18nKey}`} className="bg-white">
      <section className="bg-[#0B1E36] text-white">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-14 sm:py-16">
          <h1
            className="text-3xl sm:text-4xl font-bold tracking-tight"
            style={{ fontFamily: "Plus Jakarta Sans, sans-serif" }}
          >
            {data.title}
          </h1>
          <p className="mt-3 text-xs uppercase tracking-[0.22em] text-emerald-300">
            {data.updated}
          </p>
        </div>
      </section>
      <article className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-14 sm:py-16">
        {data.intro && (
          <p className="text-base text-slate-700 leading-relaxed mb-8 border-l-2 border-emerald-600 pl-4">
            {data.intro}
          </p>
        )}
        <div className="space-y-8">
          {data.sections.map((s, i) => (
            <section key={i} data-testid={`legal-section-${i}`}>
              <h2 className="text-xl font-semibold text-slate-900">{s.title}</h2>
              <p className="mt-3 text-slate-700 leading-relaxed">{s.body}</p>
            </section>
          ))}
        </div>
      </article>
    </div>
  );
};

export default LegalPage;
